export type Sleep = (ms: number) => Promise<void>;

export const defaultSleep: Sleep = (ms) =>
	new Promise((resolve) => setTimeout(resolve, ms));
